import { ResponseInterceptor } from 'app/services/api/interfaces';
import { AxiosError, AxiosResponse } from 'axios';

export const unauthorizedInterceptor: ResponseInterceptor = {
  onFulfilled: (res: AxiosResponse) => Promise.resolve(res),
  onRejected: (err: AxiosError) => {
    if (err?.response && [401].includes(err.response.status)) {
      // TODO: add logic here
    }

    return Promise.reject(err);
  },
};
